import React, { useEffect, useState } from "react";
import { Checkbox, Empty, Modal, Spin } from "antd";
import RequestHandler from "util/RequestHandler";
import {
  trackBannerClick,
  resolveBannerTargetUrl,
  openBannerTarget,
  BANNER_SCREEN_POPUP,
} from "util/BannerClickActions";
import { dismissBannerPromoFor24h } from "util/BannerPromoSession";
import { GiftOutlined } from "@ant-design/icons";
import TahsiliteOzelBadge from "assets/images/tahsiLite - buton-badge.svg";
import "./BannerPromoModal.css";
import config from "util/ApiforContext";

const BannerPromoIcon = (props) => <GiftOutlined {...props} aria-hidden />;

const formatDecimal = (value) => {
  if (value == null) return null;
  return Number(value).toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BannerPromoModal = ({ visible, onCancel, tenantId = null }) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dismissChecked, setDismissChecked] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!visible) {
      setBanners([]);
      setDismissChecked(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    let url = "/Banner/GetActive";
    if (tenantId) {
      url += "?tenantId=" + tenantId;
    }

    RequestHandler.get(url)
      .then((response) => {
        if (cancelled) return;
        const list = Array.isArray(response) ? response : [];
        setBanners(list.filter((b) => b && b.imagePath));
      })
      .catch(() => {
        if (!cancelled) setBanners([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [visible, tenantId]);

  const handleBannerClick = (banner) => {
    trackBannerClick({
      bannerId: banner.id,
      screenName: BANNER_SCREEN_POPUP,
      firmId: null,
    });
    const target = resolveBannerTargetUrl(banner, { isLogin: true });
    openBannerTarget(target);
  };

  const handleClose = () => {
    if (dismissChecked) {
      dismissBannerPromoFor24h();
    }
    onCancel();
  };

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      footer={null}
      width="90vw"
      style={{ maxWidth: 920 }}
      destroyOnClose
      title={
        <span className="banner-promo-modal-title">
          <BannerPromoIcon style={{ fontSize: 20 }} />
          Kampanyalar
          {banners.length > 0 && (
            <span className="banner-promo-modal-count">
              İşletmen için seçtiğimiz {banners.length} fırsat
            </span>
          )}
        </span>
      }
    >
      <Spin spinning={loading}>
        <div className="banner-promo-modal-list">
          {!loading && banners.length === 0 ? (
            <Empty description="Aktif kampanya bulunamadı" />
          ) : (
            banners.map((banner) => (
              <div
                key={banner.id}
                className="banner-promo-card"
                onClick={() => handleBannerClick(banner)}
                role="button"
                tabIndex={0}
              >
                <div className="banner-promo-card-image-wrapper">
                  <img
                    src={TahsiliteOzelBadge}
                    alt="Tahsilite'a Özel"
                    className="banner-promo-card-badge banner-promo-card-badge--overlay"
                  />
                  <img
                    src={banner.imagePath}
                    alt={banner.name || "banner"}
                    className="banner-promo-card-image"
                  />
                </div>
                <div className="banner-promo-card-info">
                  <img
                    src={TahsiliteOzelBadge}
                    alt="Tahsilite'a Özel"
                    aria-hidden={true}
                    className="banner-promo-card-badge banner-promo-card-badge--in-info"
                  />
                  <div className="banner-promo-card-name">
                    {banner.bankName && (
                      <span className="banner-promo-card-bank">{banner.bankName}</span>
                    )}
                    {banner.bankName && " · "}
                    <span className="banner-promo-card-campaign">
                      {banner.name || "Kampanya"}
                    </span>
                  </div>
                  <div className="banner-promo-card-details">
                    <div className="banner-promo-card-detail">
                      <span className="banner-promo-card-detail-value">
                        {banner.interestRate != null
                          ? `%${formatDecimal(banner.interestRate)}`
                          : "—"}
                      </span>
                      <span className="banner-promo-card-detail-label">
                        Faiz Oranı
                      </span>
                    </div>
                    <div className="banner-promo-card-detail">
                      <span className="banner-promo-card-detail-value">
                        {banner.totalAmount != null
                          ? `${formatDecimal(banner.totalAmount)} TL`
                          : "—"}
                      </span>
                      <span className="banner-promo-card-detail-label">
                        Toplam Tutar
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {!loading && banners.length > 0 && (
          <div className="banner-promo-modal-footer">
            <Checkbox
              checked={dismissChecked}
              onChange={(e) => setDismissChecked(e.target.checked)}
            >
              24 saat tekrar gösterme
            </Checkbox>
                  <button
                    type="button"
                    className="banner-promo-all-link"
                    onClick={() => {
                      onCancel();
                      window.open("https://panel.finika.co/register", "_blank", "noopener,noreferrer");
                    }}
                  >
                    Tüm kampanyalar &rsaquo;
                  </button>
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export { BannerPromoIcon };
export default BannerPromoModal;
